import { useCallback, useEffect, useState } from "react";
import {
  getCompanyVerificationStatusList,
  ICompanyVerificationStatusesConfig,
  ICompanyVerificationStatusObject,
} from "../network";
import { VerificationStatus } from "../utils/getStatus";

const {
  NEW,
  INFORMATION_REQUESTED,
  SENT_TO_VERIFICATION,
  ON_FINAL_REVIEW,
  ACCEPTED,
  CANCELED,
  DELETED,
} = VerificationStatus;

const STATUS_ORDER = [
  NEW,
  SENT_TO_VERIFICATION,
  INFORMATION_REQUESTED,
  ON_FINAL_REVIEW,
  ACCEPTED,
  CANCELED,
  DELETED,
];

export const useGetCompanyVerificationStatuses = (): [
  ICompanyVerificationStatusesConfig,
  boolean,
  Error | null,
  () => void
] => {
  const [result, setResult] = useState<ICompanyVerificationStatusesConfig>({
    object: {} as ICompanyVerificationStatusObject,
    filters: [],
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await getCompanyVerificationStatusList();

      const statusesObject = {} as ICompanyVerificationStatusObject;
      for (let verifiactionStatus of response) {
        statusesObject[verifiactionStatus.status] = verifiactionStatus;
      }
      const statusesConfig = {
        object: statusesObject,
        filters: [...response].sort(
          (a, b) =>
            STATUS_ORDER.indexOf(a.status) - STATUS_ORDER.indexOf(b.status)
        ),
      };
      setResult(statusesConfig);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    request();
  }, [request]);

  return [result, isLoading, error, request];
};
